import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navbar } from '@/shared/components/Navbar';
import { Footer } from '@/shared/components/Footer';

export function App() {
  const { t } = useTranslation();

  return (
    <>
      <a className="skip-link" href="#contenido">
        {t('notFound.back')}
      </a>
      <Navbar />
      <main id="contenido">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
